import { CloseOutlined } from '@ant-design/icons';
import { type ButtonProps, Modal } from 'antd';

import type { ReactNode } from 'react';

interface NotificationModalProps {
  dataTestId?: string;
  isModalOpen: boolean;
  title: string | ReactNode;
  handleSubmit: () => void;
  okText?: string | ReactNode;
  cancelText?: string | ReactNode;
  showCancelButton?: boolean;
  content?: string | ReactNode;
  okButtonProps?: ButtonProps;
  cancelButtonProps?: ButtonProps;
  handleCancel?: () => void;
  customCloseIcon?: ReactNode;
  titleDataTestId?: string;
  contentDataTestId?: string;
  confirmLoading?: boolean;
}

export const NotificationModal = (props: NotificationModalProps) => {
  const {
    okText = '',
    cancelText = '',
    isModalOpen,
    title,
    showCancelButton,
    handleSubmit,
    handleCancel,
    content,
    okButtonProps,
    cancelButtonProps,
    dataTestId,
    customCloseIcon,
    titleDataTestId,
    contentDataTestId,
    confirmLoading,
  } = props;

  return (
    <Modal
      data-testid={dataTestId}
      okText={okText}
      cancelText={cancelText}
      cancelButtonProps={{
        ...cancelButtonProps,
        style: { display: !showCancelButton ? 'none' : 'initial' },
      }}
      title={
        <span {...(titleDataTestId ? { 'data-testid': titleDataTestId } : {})}>
          {title}
        </span>
      }
      open={isModalOpen}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={confirmLoading}
      okButtonProps={okButtonProps}
      closeIcon={customCloseIcon || <CloseOutlined />}
    >
      <span
        {...(contentDataTestId ? { 'data-testid': contentDataTestId } : {})}
      >
        {content}
      </span>
    </Modal>
  );
};
